const types = {
  CERTIFICATE_DATA: "CERTIFICATE_DATA",
  CERTIFICATE_DATA_RESPONSE: "CERTIFICATE_DATA_RESPONSE",
  CERTIFICATE_DATA_CLEAR: "CERTIFICATE_DATA_CLEAR",

  GET_ALL_CERTIFICATIONS: "GET_ALL_CERTIFICATIONS",
  GET_ALL_CERTIFICATIONS_RES: "GET_ALL_CERTIFICATIONS_RES",
  GET_ALL_CERTIFICATIONS_CLEAR: "GET_ALL_CERTIFICATIONS_CLEAR",

  GET_SINGLE_CERTIFICATIONS: "GET_SINGLE_CERTIFICATIONS",
  GET_SINGLE_CERTIFICATIONS_RES: "GET_SINGLE_CERTIFICATIONS_RES",
  GET_SINGLE_CERTIFICATIONS_CLEAR: "GET_SINGLE_CERTIFICATIONS_CLEAR",

  //Popular Certificates
  GET_POPULAR_CERTIFICATIONS: "GET_POPULAR_CERTIFICATIONS",
  GET_POPULAR_CERTIFICATIONS_RES: "GET_POPULAR_CERTIFICATIONS_RES",
  GET_POPULAR_CERTIFICATIONS_CLEAR: "GET_POPULAR_CERTIFICATIONS_CLEAR",

  //Global Search Certificates
  GLOBAL_SEARCH_CERTIFICATES: "GLOBAL_SEARCH_CERTIFICATES",
  GLOBAL_SEARCH_CERTIFICATES_RESPONSE: "GLOBAL_SEARCH_CERTIFICATES_RESPONSE",
  GLOBAL_SEARCH_CERTIFICATES_CLEAR: "GLOBAL_SEARCH_CERTIFICATES_CLEAR",
};

export default types;
